import { render, staticRenderFns } from "./folders-drop.vue?vue&type=template&id=1a3169ca&scoped=true"
import script from "./folders-drop.vue?vue&type=script&lang=js"
export * from "./folders-drop.vue?vue&type=script&lang=js"
import style0 from "./folders-drop.vue?vue&type=style&index=0&id=1a3169ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3169ca",
  null
  
)

export default component.exports